import { Auth } from 'aws-amplify';
import { gql, GraphQLClient } from 'graphql-request';
import { Variables } from 'graphql-request/dist/types';
import { RequestInit } from 'graphql-request/dist/types.dom';

export type GraphClientResponse<T> = {
	data: T,
	debug?: {[key: string]: any}[],
	error?: {[key: string]: any}[],
}

export type GraphClientMode = "stage" | "production";

class Client
{
	private endpoint = "https://graph.eismann.io/";
	private mode: GraphClientMode = "production";

	constructor()
	{
		this.setEndpoint("production");
	}

	public setEndpoint(type: GraphClientMode): void
	{
		console.log("Graph:Client", "setEndpoint", "type:", type);
		this.mode = type;

		if(process.env.NODE_ENV && process.env.NODE_ENV === "development")
		{
			this.setEndpointUrl("http://localhost:8089/");
		}
		else if(type === "stage")
		{
			this.setEndpointUrl("https://stage.graph.eismann.io/");
		}
		else if(type === "production")
		{
			this.setEndpointUrl("https://graph.eismann.io/");
		}
	}

	public setEndpointUrl(url: string): void
	{
		this.endpoint = url;
	}

	public getMode(): GraphClientMode
	{
		return this.mode;
	}

	public async request<T>(query: string, variables?: Variables | undefined ): Promise<T>
	{
		const requestInit: RequestInit = {
			headers: {},
		};
		const client = new GraphQLClient(this.endpoint, requestInit);
		const session = await Auth.currentSession();
		const idToken = session.getIdToken();

		console.log("ID-TOKEN", idToken.getJwtToken());

		client.setHeader("X-JWT-COGNITO", idToken.getJwtToken());
		const response = await client.request<T, Variables>(query, variables);

		console.log("RESPONSE", response);

		return response;
	}
}

const c = new Client();

// if(process.env.NODE_ENV && process.env.NODE_ENV === "development")
// {
//     c.setEndpoint("production");
// }

export const client = c;